<template>
	<MainLayout>
		<div class="container-sm">
			<b-card class="rounded">
				<b-card-body>
					<h4>Acceso denegado!</h4>
					<p class="text-muted">Ya no tienes acceso a este proveedor, sin embargo puedes seleccionar otro para continuar.</p>

					<!-- selects view -->
					<b-form v-if="countAll >= 10" @submit="doChangePlatform">
						<div class="bg-light p-4 rounded">
							<b-form-group label-size="sm" label-class="text-muted" label="Cambiar de" class="mb-3">
								<b-form-select v-model="sassSelected" @change="fillSassSelected($event)" class="mt-2">
									<b-form-select-option :value="null" disabled>{{this.$t('global.selectOption')}}</b-form-select-option>
									<b-form-select-option v-if="loadSuppliers" value="supplier">{{this.$t('global.supplier')}}</b-form-select-option>
									<b-form-select-option v-if="loadPos" value="pos">{{this.$t('global.pointOfSale')}}</b-form-select-option>
								</b-form-select>
							</b-form-group>

							<b-form-group label-size="sm" label-class="text-muted" :label="$t('global.selectOption')" class="mb-4">
								<b-form-select v-model="sassReferenceId" :options="sassOpts" class="mt-2" required/>
							</b-form-group>

							<div class="text-center">
								<b-button variant="primary" block type="submit">{{ $t('global.change') }}</b-button>
							</div>
						</div>
					</b-form>

					<!-- buttons view -->
					<b-row v-if="countAll > 1 && countAll < 10" class="pb-3">
						<!-- pos -->
						<b-col v-if="loadPos" md="6">
							<div class="bg-light p-4 rounded">
								<h5>Puntos de venta</h5>

								<b-button
									v-for="(item,i) in $root.auxVars.userPointOfSalesAccess"
									:key="i"
									variant="info"
									class="mr-2 my-1"
									size="sm"
									v-b-tooltip.hover v-b-tooltip.placement.auto
									title="Clic para cambiar a este punto de venta"
									@click="goToPlatform('pos', item.value)"
								>
									{{ item.text }}
								</b-button>
							</div>
						</b-col>

						<!-- suppliers -->
						<b-col md="6" v-if="loadSuppliers && Object.keys(supplier).length > 0">
							<div class="bg-light p-4 rounded">
								<h4>Proveedores</h4>
								<b-button
									v-for="(item,i) in supplier"
									:key="i"
									variant="warning"
									class="mr-2 my-1"
									size="sm"
									v-b-tooltip.hover v-b-tooltip.placement.auto
									title="Clic para cambiar a este proveedor"
									@click="goToPlatform('supplier', item.value)"
								>
									{{ item.text }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from "../sections/layout/MainLayout.vue";
import chatProvider from "@/components/helpers/helpers-chat";

export default {
	components: { MainLayout },
	data() {
		return {
			isActive: false,
			sassReferenceId: null,
			sassSelected: null,
			sassOpts: [],
			supplier: [],
		}
	},
	methods: {
		// logic --
		fillSassSelected() {
			if (this.sassSelected === 'supplier') {
				this.sassOpts = this.$root.auxVars.userSuppliersAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id)
			} else if (this.sassSelected === 'pos') {
				this.sassOpts = this.$root.auxVars.userPointOfSalesAccess
			}
		},

		_process(type, referenceId) {
			this.$root.showWarning({
				message: 'Esta seguro de que desea cambiar de sistema?',
				okAction: (event, setLoading, close) => {
					setLoading(true)

					switch (type) {
						case 'supplier':
							this.$root.api.post('/auth/system', null, {
								headers: {
									"X-SC-TYPE": 'supplier',
									"X-SC-SYSTEM": referenceId,
								}
							}).then((response) => {
								this.$root.store.setSystemData(response.data)

								if(this.$route.path === '/')
									location.reload()
								else
									this.$router.push('/')

								setLoading(false)
							}).catch((err) => {
								this.$root.handleRequestError(err)
								close()
							})
							break;
						case 'pos':
							window.location = process.env.VUE_APP_POS + '/login?referenceId=' + referenceId + '&token=' + this.$root.store.state.currentToken
							setLoading(false)
							this.$root.auxVars.clearResources();
							this.$root.store.clearUser();
							if (this.$root.chatStarted) {
								chatProvider.shutdown();
								this.$root.chatStarted = false;
							}
							break;
						default:
							this.$root.showAlert('Seleccione un sistema valido', {variant: 'danger'})
							break;
					}
				}
			})
		},

		supplierOpts() {
			this.supplier = this.$root.auxVars.userSuppliersAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id)
		},

		// event for select view
		doChangePlatform(evt) {
			evt.preventDefault();
			this._process(this.sassSelected, this.sassReferenceId)
		},

		// event for btns view
		goToPlatform(type, reference) {
			this._process(type, reference)
		}
	},
	mounted(){
		this.supplierOpts()
	},
	computed: {
		resource() {
			return this.$root.auxVars.userSuppliersAccess
		},
		countAll() {
			let pos = this.$root.auxVars.userPointOfSalesAccess
			let sup = this.$root.auxVars.userSuppliersAccess

			let total = 0
			if(typeof pos != 'undefined')
				total = parseInt(pos.length) + parseInt(sup.length)
			else
				total = parseInt(sup.length)

			return total;
		},
		loadSuppliers() {
			return typeof this.$root.auxVars.userSuppliersAccess != 'undefined';
		},
		loadPos() {
			return typeof this.$root.auxVars.userPointOfSalesAccess != 'undefined';
		}
	},
	watch: {
		resource() {
			this.supplierOpts()
		}
	}
}
</script>



















